module.exports = __webpack_public_path__ + "static/media/fab-question.b02d0254.svg";